import '../css/main.css'

import { createPinia } from 'pinia'
import { createApp, h } from 'vue'
import { createInertiaApp, usePage } from '@inertiajs/vue3'
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers'
import { ZiggyVue } from 'ziggy-js';
import { useMainStore } from '@/stores/main.js'
import vuetify from './vuetify'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Kulfood'
const pinia = createPinia()

createInertiaApp({
    //title: (title) => `${title} - ${appName}`, // TODO title not working
    resolve: (name) =>
        resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        /*if (props.initialPage.props.auth.user) {
          useMainStore().setUser({
            name: props.initialPage.props.auth.user.name + " " + props.initialPage.props.auth.user.last_name,
            email:props.initialPage.props.auth.user.email,
          })
        }*/
        return createApp({
            render: () => h(App, props),
        })
        .use(plugin)
        .use(pinia)
        .use(ZiggyVue, Ziggy)
        .use(vuetify)
        .use(VueDatePicker)
        .mount(el)
    },
    progress: {
        color: '#4B5563'
    },

})
